import { ArrowDownRight, Check, MapPin, Phone } from "lucide-react";
import { useState } from "react";
import Reveal from "@/components/Reveal";
import { getText } from "@/data/siteData";

export default function Hero({ site, lang }) {
  const [zip, setZip] = useState("");
  const [zipMessage, setZipMessage] = useState("");
  const phoneHref = `tel:${site.phone.replace(/\D/g, "")}`;
  const checkZip = (event) => {
    event.preventDefault();
    const supported = /^(20|21)/.test(zip.trim());
    setZipMessage(supported ? (lang === "en" ? "You are in our Maryland service range." : "Estás dentro de nuestra zona de servicio en Maryland.") : (lang === "en" ? "Send us your ZIP and we will confirm your route." : "Envíanos tu ZIP y confirmaremos tu ruta."));
  };
  const titleLines = getText(site, "headline", lang).split("\n");
  return (
    <section className="hero-section" id="top">
      <div className="page-shell hero-grid">
        <div className="hero-copy">
          <Reveal className="eyebrow" delay={80}><span className="eyebrow-rule" />{getText(site, "hero_badge", lang)}</Reveal>
          <h1 className="hero-title" data-testid="hero-headline">
            {titleLines.map((line, index) => <span className={`hero-line ${index === 1 ? "hero-line-gold" : ""}`} key={line}>{line}</span>)}
          </h1>
          <Reveal className="hero-description" delay={330}><p>{getText(site, "subtitle", lang)}</p></Reveal>
          <Reveal className="hero-actions" delay={420}>
            <a className="button button-primary" href="#contact" data-testid="hero-contact-button">{getText(site, "primary_cta", lang)}<ArrowDownRight size={18} aria-hidden="true" /></a>
            <a className="button button-quiet" href={phoneHref} data-testid="hero-direct-call-button"><Phone size={16} aria-hidden="true" />{getText(site, "secondary_cta", lang)}</a>
          </Reveal>
          <Reveal className="hero-proof" delay={520}>
            <span><Check size={14} aria-hidden="true" /> {lang === "en" ? "Residential & commercial" : "Residencial y comercial"}</span>
            <span><Check size={14} aria-hidden="true" /> {lang === "en" ? "Family-led service" : "Servicio familiar"}</span>
            <span><Check size={14} aria-hidden="true" /> {lang === "en" ? "Baltimore to all Maryland" : "De Baltimore a todo Maryland"}</span>
          </Reveal>
          <form className="zip-check" onSubmit={checkZip}>
            <div className="zip-label"><MapPin size={15} aria-hidden="true" /><span>{lang === "en" ? "Check your Maryland route" : "Revisa tu ruta en Maryland"}</span></div>
            <div className="zip-row"><input value={zip} onChange={(event) => setZip(event.target.value)} placeholder={lang === "en" ? "ZIP code" : "Código ZIP"} inputMode="numeric" maxLength={5} data-testid="hero-zipcode-input" /><button type="submit" data-testid="hero-zipcode-check-button">{lang === "en" ? "Check" : "Revisar"}</button></div>
            {zipMessage && <p className="zip-message" data-testid="hero-zipcode-message">{zipMessage}</p>}
          </form>
        </div>
        <Reveal className="hero-visual" delay={180}>
          <div className="hero-image-frame">
            <img src={site.hero_image_url} alt={`${site.brand_name} brand and cleaning service`} data-testid="hero-brand-image" />
            <span className="image-corner image-corner-one" /><span className="image-corner image-corner-two" />
          </div>
          <div className="hero-visual-caption"><span className="caption-index">01</span><span>{lang === "en" ? "The Glow standard / Baltimore, MD" : "El estándar Glow / Baltimore, MD"}</span><span className="caption-line" /></div>
        </Reveal>
      </div>
    </section>
  );
}
